export const RECOMMENDATIONS_ROOT_PATH = 'new-recommendations'
